import React from 'react'
import General from '../../../../utils/General'
const DEFAULT_CSS = {
  'hue-rotate': 0,
  saturate: 1,
  brightness: 1,
  contrast: 1,
  invert: 0,
  sepia: 0,
  grayscale: 0,
  opacity: 1,
}
export default class Filter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: '_' + General.uuid(),
      filter: props.filter,
      intensity: props.intensity,
      styles: props.styles,
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }

  _getCssFilters(filter) {
    let css = ''
    for (var [key, value] of Object.entries(filter.css.filters)) {
      if (this.state.intensity) {
        let defaultValue = DEFAULT_CSS[key]
        let range = value - defaultValue
        let gain = range * (this.state.intensity / 100.0)
        value = defaultValue + gain
      }
      if (key === 'hue-rotate') {
        value += 'deg'
      }
      css += `${key}(${value})`
    }
    return css
  }

  _getCssBefore(filter) {
    let css = ''
    for (var [key, value] of Object.entries(filter.cssBefore)) {
      if (key === 'hue-rotate') {
        value += 'deg'
      }
      css += `${key.replace('__', '')}: ${value};`
    }
    if (!css.includes('opacity') && this.state.intensity) {
      css += `opacity: ${this.state.intensity / 100.0};`
    }
    return css
  }

  _getCssAfter(filter) {
    let css = ''
    for (var [key, value] of Object.entries(filter.cssAfter)) {
      if (key === 'hue-rotate') {
        value += 'deg'
      }
      if (key === 'opacity' && this.state.intensity) {
        let max = filter.cssAfter.opacity
        let min = 0
        let range = max - min
        let gain = range * (this.state.intensity / 100.0)
        value = gain
      }
      css += `${key.replace('__', '')}: ${value};`
    }
    if (!css.includes('opacity') && this.state.intensity) {
      css += `opacity: ${this.state.intensity / 100.0};`
    }
    return css
  }

  _getCSS(filter) {
    let cssStatic = `
        content: '';
        display: block;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        position: absolute;
        pointer-events: none;
    `
    let css = this._getCssFilters(filter)
    let cssBefore = this._getCssBefore(filter)
    let cssAfter = this._getCssAfter(filter)

    let figureId = this.state.id
    let maskId = figureId + '_mask'
    return `
      #${figureId}{
          --webkit-filter: ${css};
          filter: ${css};
      }
      #${maskId} {
        height: 100%;
        width: 100%;
      }
      #${maskId}:before {
          ${cssStatic}
          z-index: 2
      }
      #${maskId}:after {
          ${cssStatic}
          z-index: 3
      }
      #${maskId}::before {
          ${cssBefore} 
      }
      #${maskId}::after{
          ${cssAfter}
      }
      #${figureId} img {
          z-index: 1;
          object-fit: cover;
      }
    `
  }

  _getStyles(styles) {
    if (!styles) {
      return {}
    }
    return {
      filter: `blur(${styles.blur}px) brightness(${styles.brightness}) 
          contrast(${styles.contrast}%) opacity(${styles.opacity}) saturate(${styles.saturation}%) 
          grayscale(${styles.grayScale}%) hue-rotate(${styles.hue}deg) invert(${styles.invert}%) sepia(${styles.sepia}%)`,
      transform: `rotate(${styles.rotate}deg) scale(${styles.scale}) 
        skew(${styles.skewX}deg,${styles.skewY}deg) rotateX(${styles.rotateX}deg) 
        rotateY(${styles.rotateY}deg)`,
      border: `${styles.borderWidth}px solid ${styles.borderColor}`,
      borderRadius: `${styles.borderRadius}%`,
    }
  }

  render() {
    let { filter, id, styles } = this.state
    if (!filter) {
      return null
    }
    return (
      <>
        <style
          dangerouslySetInnerHTML={{
            __html: this._getCSS(filter),
          }}
        />
        <div id={id} className="filter-overlay">
          <div
            id={id + '_mask'}
            className="filter-mask"
            style={this._getStyles(styles)}
          >
            {this.props.children}
          </div>
        </div>
      </>
    )
  }
}
